import { Grid } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
} from "@websential/cosmic-v20";
import React from "react";

export interface IGlobalVariablesHeader {
	yearList: any;
	dateList: any;
	provinceList: any;
	onYearSelectionChangeHandler: (params: any) => void;
	onProvinceSelectionChangeHandler: (params: any) => void;
	onDateSelectionChangeHandler: (params: any) => void;
}
export const GlobalVariablesHeader: React.FC<IGlobalVariablesHeader> = ({
	yearList,
	provinceList,
	dateList,
	onYearSelectionChangeHandler,
	onProvinceSelectionChangeHandler,
	onDateSelectionChangeHandler,
}) => {
	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					border: "1px solid rgba(0, 0, 0, 0.12)",
					borderRadius: "3px",
					marginTop: "16px",
					background: "#ffffff",
				}}
			>
				<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}
					sx={{ paddingTop: "25px" }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName="taxYear"
						label="Load Year"
						labelPosition={LabelPosition.Top}
						testId={`year-list`}
						items={yearList ?? []}
						showEmpty={true}
						onSelectionChangeHandler={onYearSelectionChangeHandler}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName="province"
						label="Load Province"
						labelPosition={LabelPosition.Top}
						testId={`province-list`}
						items={provinceList ?? []}
						showEmpty={true}
						onSelectionChangeHandler={onProvinceSelectionChangeHandler}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName="date"
						label="Effective Date"
						labelPosition={LabelPosition.Top}
						testId={`date-list`}
						items={dateList ?? []}
						showEmpty={true}
						onSelectionChangeHandler={onDateSelectionChangeHandler}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}></Grid>
			</Grid>
		</>
	);
};
